import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('helpers.getGrnStatusText', {
    statusNotReceived: 'Not received',
    statusPartiallyReceived: 'Partially received',
    statusFullyReceived: 'Fully received',
});
